import type { FC } from 'react';
import { IoCheckmarkOutline } from 'react-icons/io5';

import { Menu } from '@mantine/core';

import { BreakerType, BreakerTypes } from 'models';
import { FormatHelpers } from 'helpers/formatters';

import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { InlineFilters } from 'components/component-overview/inline-filters/InlineFilters';
import { SearchService } from 'components/component-overview/services/SearchService';

const InlineFiltersBreakerType: FC = () => {
    const { type, breakerType } = useComponentSearchFilters();

    const toggleBreakerType = (value: BreakerTypes) => {
        SearchService.setFilter(
            'breakerType',
            breakerType?.includes(value)
                ? breakerType.filter((selected) => selected !== value)
                : [...(breakerType ?? []), value],
        );
    };

    const onRemove = () => {
        SearchService.setFilter('breakerType', undefined);
    };

    if (type !== 'breaker') return null;

    const formattedValue = BreakerType.options
        .filter(({ value }) => breakerType?.includes(value))
        .map(({ value }) => FormatHelpers.formatBreakerType(value))
        .join(', ');

    return (
        <InlineFilters.Section
            label={formattedValue ? undefined : 'Breaker Type'}
            body={formattedValue}
            active={!!breakerType?.length}
            onRemove={breakerType?.length ? onRemove : undefined}
            popoverContent={
                <>
                    <Menu.Label>Breaker Type</Menu.Label>
                    {BreakerType.options.map(({ value, label }) => (
                        <Menu.Item
                            key={value}
                            onClick={() => toggleBreakerType(value)}
                            leftSection={breakerType?.includes(value) ? <IoCheckmarkOutline /> : null}
                        >
                            {label}
                        </Menu.Item>
                    ))}
                </>
            }
        />
    );
};

export { InlineFiltersBreakerType };
